import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import {
    STORE_SEARCHNAME,
    STORE_SEARCHVALUE,
    STORE_SEARCHTRUE,
    STORE_SEARCHTYPE,
    STORE_NOTIFICATIONS_COUNT,
    STORE_NOTIFICATIONS,
    NotificationsType,
    SearchValue,
    STORE_OPEN_VIDEO_PLAYER,
    STORE_VIDEO_SIGNED_URL,
    STORE_SEARCHLOADING,
    STORE_VERTICAL_VIEW_SCREEN,
    STORE_LOADER
} from 'src/reducers/landingPage';

import axios, { AxiosResponse } from 'axios';
import {
    STORE_DASHBOARD,
    STORE_DASHBOARD_LIVECOUNT,
    STORE_DASHBOARD_COMPLETEDORDER,
    STORE_DASHBOARD_ONHOLD,
    STORE_DASHBOARD_RETURNED,
    DataItem,
    STORE_LARGEST_NUMBER,
    STORE_CHART, DataItemInitial, STORE_DASHBOARD_DESIGNREADY,
    STORE_DASHBOARD_COMPLETEDORDERCNT
} from 'src/reducers/dashboard';
import {
    BranchData,
    STORE_ORDERDATABRANCH,
    ManufacturerData,
    STORE_ORDERDATAMANUFACT,
    STORE_ORDERDATATAT
} from 'src/reducers/fileUpload';
import {
    STORE_USERPROFILEDATA,
    STORE_CUSTOMERNAME_PROFILE,
    STORE_CUSTOMEREMAIL_PROFILE,
    STORE_CUSTOMERPHONENUMBER_PROFILE,
    STORE_CUSTOMERADDRESSONE_PROFILE,
    STORE_CUSTOMERADDRESSTWO_PROFILE,
    STORE_CUSTOMERCOUNTRY_PROFILE,
    STORE_CUSTOMERSTATE_PROFILE,
    STORE_CUSTOMERPRODUCT_PROFILE,
    STORE_CUSTOMERSCANNER_PROFILE,
    STORE_CUSTOMERCONTACTNAME_PROFILE,
    STORE_CUSTOMERCONTACTNUMBER_PROFILE,
    STORE_CUSTOMERCOMMENT_PROFILE,
    STORE_CUSTOMEROCCLUSION,
    STORE_CUSTOMERDESIGNTYPE,
    STORE_CUSTOMERPONTICDESIGN,
    STORE_CUSTOMERCONTACT,
    STORE_CUSTOMERMODELTYPE,
    STORE_CUSTOMERNOTE,
    STORE_DESIGNSOFTWARES_DATA,
    STORE_CUSTOMERDSOFT_PROFILE
} from 'src/reducers/userProfile';
import { RedesignReasons, STORE_FEEDBACKPARAMETER, STORE_FEEDBACKTYPE, STORE_REDESIGN_REASONS } from '../reducers/completeorderfile';

import { STORE_ERROR_FILES_UPLOADED, STORE_ERROR_FILES_UPLOADED_MSG } from 'src/reducers/errors';
import { GetFileData } from 'src/reducers/rxForm';

let cancelTokenSource = axios.CancelToken.source();

let notiTimer: NodeJS.Timer;

export const covertToIntegers = (data: DataItemInitial[]) => {
    const alteredData: DataItem[] = [];
    data.map((item) => {
        if (item.odate !== '') {
            const newData = {
                rowno: parseInt(item.rowno, 10),
                odate: item.odate,
                mno: parseInt(item.mno, 10),
                completed: parseInt(item.completed, 10),
                intat: parseInt(item.intat, 10)
            };
            alteredData.push(newData);
        }
    });
    return alteredData;
};

export const getMastersData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    await axios({
        method: 'GET',
        url: `${getState().environment.API_URL}getMastersData?userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            sessionid: getState().user.userDetails.s || ''
        },
    }).then(function (response: AxiosResponse) {

        if (response.data.manufacturers.length > 0) {
            const orderDataManufacturer: ManufacturerData[] = response.data.manufacturers;
            dispatch({ type: STORE_ORDERDATAMANUFACT, orderDataManufacturer } as AnyAction);
        }
        // if (response.data.tattypes.length > 0 && getState().user.userDetails.ugroup === 'Lab') {
        //     const orderDataTat = response.data.tattypes;
        //     dispatch({ type: STORE_ORDERDATATAT, orderDataTat } as AnyAction);
        // }
        if ( response.data.tattypes.length > 0 &&
            (getState().user.userDetails.ugroup === 'Lab' ||
             getState().user.userDetails.ugroup === 'Manufacturer' ||
             getState().user.userDetails.ugroup === 'EDDL')
        ) {
            const orderDataTat = response.data.tattypes;
            dispatch({ type: STORE_ORDERDATATAT, orderDataTat } as AnyAction);
        }
        if (response.data.designsoftware.length > 0) {
            const designSoftwares = response.data.designsoftware;
            dispatch({ type: STORE_DESIGNSOFTWARES_DATA, designSoftwares } as AnyAction);
        }
        if (response.data.feedbackparameter.length > 0) {
            const feedbackparameters = response.data.feedbackparameter;
            dispatch({ type: STORE_FEEDBACKPARAMETER, feedbackparameters } as AnyAction);
        }
        if (response.data.feedbacktype.length > 0) {
            const feedbacktypes = response.data.feedbacktype;
            dispatch({ type: STORE_FEEDBACKTYPE, feedbacktypes } as AnyAction);
        }
        if (response.data.custsbus.length > 0) {
            const orderDataBranch: BranchData[] = response.data.custsbus;
            dispatch({ type: STORE_ORDERDATABRANCH, orderDataBranch } as AnyAction);
        }
        if (response.data.custprofile.length > 0) {
            const userProfiledata = response.data.custprofile[0];
            dispatch({ type: STORE_USERPROFILEDATA, userProfiledata } as AnyAction);

            if (response.data.custprofile[0].ordview_layout && response.data.custprofile[0].ordview_layout === '1') {
                dispatch({ type: STORE_VERTICAL_VIEW_SCREEN, verticalViewScreen: true } as AnyAction);
            } else {
                dispatch({ type: STORE_VERTICAL_VIEW_SCREEN, verticalViewScreen: false } as AnyAction);
            }

            const custname = getState().userProfileData.userProfiledata.custname;
            const custemail = getState().userProfileData.userProfiledata.emailid;
            const custnumber = getState().userProfileData.userProfiledata.phoneno;
            const custaddressone = getState().userProfileData.userProfiledata.address1;
            const custaddresstwo = getState().userProfileData.userProfiledata.address2;
            const custcountry = getState().userProfileData.userProfiledata.country;
            const custstate = getState().userProfileData.userProfiledata.state;
            const custproduct = getState().userProfileData.userProfiledata.products;
            const custscanner = getState().userProfileData.userProfiledata.scanners;
            const custcontactName = getState().userProfileData.userProfiledata.contactname;
            const custcontactNumber = getState().userProfileData.userProfiledata.contactno;
            const custcomment = getState().userProfileData.userProfiledata.comments;
            const custdsoft = getState().userProfileData.userProfiledata.dsoft;
            const occlusion = getState().userProfileData.userProfiledata.occlusion;
            const designtype = getState().userProfileData.userProfiledata.designtype;
            const ponticdesign = getState().userProfileData.userProfiledata.ponticdesign;
            const contact = getState().userProfileData.userProfiledata.contact;
            const modeltype = getState().userProfileData.userProfiledata.modeltype;
            const notes = getState().userProfileData.userProfiledata.notes;

            dispatch({ type: STORE_CUSTOMERNAME_PROFILE, custname } as AnyAction);
            dispatch({ type: STORE_CUSTOMEREMAIL_PROFILE, custemail } as AnyAction);
            dispatch({ type: STORE_CUSTOMERPHONENUMBER_PROFILE, custnumber } as AnyAction);
            dispatch({ type: STORE_CUSTOMERADDRESSONE_PROFILE, custaddressone } as AnyAction);
            dispatch({ type: STORE_CUSTOMERADDRESSTWO_PROFILE, custaddresstwo } as AnyAction);
            dispatch({ type: STORE_CUSTOMERCOUNTRY_PROFILE, custcountry } as AnyAction);
            dispatch({ type: STORE_CUSTOMERSTATE_PROFILE, custstate } as AnyAction);
            dispatch({ type: STORE_CUSTOMERPRODUCT_PROFILE, custproduct } as AnyAction);
            dispatch({ type: STORE_CUSTOMERSCANNER_PROFILE, custscanner } as AnyAction);
            dispatch({ type: STORE_CUSTOMERCONTACTNAME_PROFILE, custcontactName } as AnyAction);
            dispatch({ type: STORE_CUSTOMERCONTACTNUMBER_PROFILE, custcontactNumber } as AnyAction);
            dispatch({ type: STORE_CUSTOMERCOMMENT_PROFILE, custcomment } as AnyAction);
            dispatch({ type: STORE_CUSTOMERDSOFT_PROFILE, custdsoft } as AnyAction);
            dispatch({ type: STORE_CUSTOMEROCCLUSION, occlusion } as AnyAction);
            dispatch({ type: STORE_CUSTOMERDESIGNTYPE, designtype } as AnyAction);
            dispatch({ type: STORE_CUSTOMERPONTICDESIGN, ponticdesign } as AnyAction);
            dispatch({ type: STORE_CUSTOMERCONTACT, contact } as AnyAction);
            dispatch({ type: STORE_CUSTOMERMODELTYPE, modeltype } as AnyAction);
            dispatch({ type: STORE_CUSTOMERNOTE, notes } as AnyAction);
        }

    }).catch(function (error: AxiosResponse) {
        // ==> console.error(error);

        const orderDataBranch: BranchData[] = [];
        dispatch({ type: STORE_ORDERDATABRANCH, orderDataBranch } as AnyAction);
        const orderDataManufacturer: ManufacturerData[] = [];
        dispatch({ type: STORE_ORDERDATAMANUFACT, orderDataManufacturer } as AnyAction);
    });

    return true;

};

export const getRegularIntervalData = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    for (const i of [1]) {

        await axios({
            method: 'GET',
            url: `${getState().environment.API_URL}getRegularIntervalData?userCode=${encodeURIComponent(getState().user.userDetails.userName)}`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                type: i,
                sessionid: getState().user.userDetails.s || ''
            },
        }).then(function (response: AxiosResponse) {

            if (response.data.dbwidget) {
                const userOrderdata = response.data.dbwidget[0];
                dispatch({ type: STORE_DASHBOARD, userOrderdata } as AnyAction);
                const total = getState().UserOrderData.userOrderdata.total;
                const completed = getState().UserOrderData.userOrderdata.completed;
                const onhold = getState().UserOrderData.userOrderdata.onhold;
                const returned = getState().UserOrderData.userOrderdata.returned;
                const designready = getState().UserOrderData.userOrderdata.designready;
                const completedcnt = getState().UserOrderData.userOrderdata.completedcnt;

                dispatch({ type: STORE_DASHBOARD_LIVECOUNT, total } as AnyAction);
                dispatch({ type: STORE_DASHBOARD_COMPLETEDORDER, completed } as AnyAction);
                dispatch({ type: STORE_DASHBOARD_ONHOLD, onhold } as AnyAction);
                dispatch({ type: STORE_DASHBOARD_RETURNED, returned } as AnyAction);
                dispatch({ type: STORE_DASHBOARD_DESIGNREADY, designready } as AnyAction);
                dispatch({ type: STORE_DASHBOARD_COMPLETEDORDERCNT, completedcnt } as AnyAction);
            }
            if (response.data.dbtattrend) {
                const items: DataItem[] = covertToIntegers(response.data.dbtattrend);

                const maxIntat = Math.max.apply(Math, items.map((item: DataItem) => { return item.intat; }));
                const maxCompleted = Math.max.apply(Math, items.map((item: DataItem) => { return item.completed; }));

                if (maxIntat > maxCompleted) {
                    const greatest = 'intat';
                    dispatch({ type: STORE_LARGEST_NUMBER, greatest } as AnyAction);
                } else {
                    const greatest = 'completed';
                    dispatch({ type: STORE_LARGEST_NUMBER, greatest } as AnyAction);
                }

                dispatch({ type: STORE_CHART, items } as AnyAction);
            }
            if (response.data.dbnoticnt) {
                const notificationCount = parseInt(response.data.dbnoticnt[0].cnt, 10);
                dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);
            }

        }).catch(function (error: AxiosResponse) {
            // ==> console.error(error);

            const total = '0';
            const completed = '0';
            const onhold = '0';
            const returned = '0';
            const completedcnt = '0';

            dispatch({ type: STORE_DASHBOARD_LIVECOUNT, total } as AnyAction);
            dispatch({ type: STORE_DASHBOARD_COMPLETEDORDER, completed } as AnyAction);
            dispatch({ type: STORE_DASHBOARD_ONHOLD, onhold } as AnyAction);
            dispatch({ type: STORE_DASHBOARD_RETURNED, returned } as AnyAction);
            dispatch({ type: STORE_DASHBOARD_COMPLETEDORDERCNT, completedcnt } as AnyAction);

            const items: DataItem[] = [];
            dispatch({ type: STORE_CHART, items } as AnyAction);

            const notificationCount = 0;
            dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);
        });

        await axios({
            method: 'post',
            url: `${getState().environment.API_URL
                }loadOrderData?listType=redicode`,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                sessionid: getState().user.userDetails.s || ''
            }
        }).then(function (response: AxiosResponse) {

            if (response.data.length === 1) {
                if (response.data[0].description !== '') {
                    const redesignReasons: RedesignReasons[] = response.data;
                    dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
                } else {
                    const redesignReasons: RedesignReasons[] = [];
                    dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
                }
            } else {
                const redesignReasons: RedesignReasons[] = response.data;
                dispatch({ type: STORE_REDESIGN_REASONS, redesignReasons } as AnyAction);
            }

        }).catch(error => {
            console.error(error);
        });

        getMastersData(dispatch, getState);

    }
    return true;
};

export const saveSearchType = (searchType: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_SEARCHTYPE, searchType } as AnyAction);
    };
};

export const saveLoadingState = (loader: boolean) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
        dispatch({ type: STORE_LOADER, loader: loader } as AnyAction);
    };
};

export const searchNameOrder = (searchName: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        if (getState().landingPage.searchLoading) {
            cancelTokenSource.cancel();
            cancelTokenSource = axios.CancelToken.source();
            dispatch({ type: STORE_SEARCHLOADING, searchLoading: false } as AnyAction);
        }

        dispatch({ type: STORE_SEARCHNAME, searchName } as AnyAction);
        dispatch({ type: STORE_SEARCHVALUE, searchValue: [] } as AnyAction);

        const sessionid = getState().user.userDetails.s || '';
        const params = {
            params: {
                psearchtext: '',
                psearchby: '',
                pusername: ''
            },
            user: '0'
        };
        params.params.psearchtext = getState().landingPage.searchName || '';
        params.params.psearchby = getState().landingPage.searchType || '';
        params.params.pusername = getState().user.userDetails.userName;

        let searchValue: SearchValue[] = [];

        if ((searchName.length >= 5) && !getState().landingPage.searchLoading) {

            dispatch({ type: STORE_SEARCHLOADING, searchLoading: true } as AnyAction);

            dispatch({ type: STORE_SEARCHTRUE, searchTrue: true } as AnyAction);

            dispatch({
                type: STORE_SEARCHVALUE, searchValue: [{
                    rowno: '',
                    sresult: 'Loading...',
                    dsordersid: '',
                    orderno: '',
                }]
            } as AnyAction);

            axios({
                method: 'POST',
                url: `${getState().environment.API_URL}getSearchOrderDetails`,
                cancelToken: cancelTokenSource.token,
                headers: {
                    sessionid: sessionid || ''
                },
                data: params,
            }).then(function (response: AxiosResponse) {

                searchValue = response.data;
                if (response.data.length === 1 && ((response.data[0].orderno !== undefined) && (response.data[0].orderno !== null) && (response.data[0].orderno !== ''))) {
                    dispatch({ type: STORE_SEARCHVALUE, searchValue } as AnyAction);
                } else if (response.data.length > 1) {
                    dispatch({ type: STORE_SEARCHVALUE, searchValue } as AnyAction);
                } else {
                    searchValue = [];
                    dispatch({ type: STORE_SEARCHVALUE, searchValue } as AnyAction);
                }

                dispatch({ type: STORE_SEARCHLOADING, searchLoading: false } as AnyAction);

                dispatch({ type: STORE_SEARCHTRUE, searchTrue: true } as AnyAction);

            }).catch(function (error: AxiosResponse) {
                // ==> console.error(error);
                dispatch({ type: STORE_SEARCHVALUE, searchValue: [] } as AnyAction);

                dispatch({ type: STORE_SEARCHLOADING, searchLoading: false } as AnyAction);
            });

        } else {
            const searchTrue = false;
            dispatch({ type: STORE_SEARCHTRUE, searchTrue } as AnyAction);
            dispatch({ type: STORE_SEARCHVALUE, searchValue: [] } as AnyAction);
        }

        return true;
    };
};
export const getNotifications = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    let notifications: NotificationsType[] = [{
        rowno: '1',
        id: '',
        message: 'Loading...',
        createdon: '',
        status: '',
        updatedon: '',
        orderno: '',
        dsordersid: '',
        feedback: ''
    }];
    dispatch({ type: STORE_NOTIFICATIONS, notifications } as AnyAction);

    axios({
        method: 'GET',
        url: `${getState().environment.API_URL}getNotificationDetails?userId=${encodeURIComponent(getState().user.userDetails.userName)}`,
        headers: {
            sessionid: getState().user.userDetails.s || ''
        },
    }).then(function (response: AxiosResponse) {
        if (response.data.length > 0 && response.data[0].message) {
            notifications = response.data;
            dispatch({ type: STORE_NOTIFICATIONS, notifications } as AnyAction);

            dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount: response.data.length } as AnyAction);
        } else {
            const notificationCount = 0;
            dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);
            notifications = [
                {
                    rowno: '1',
                    id: '',
                    message: 'No notifications',
                    createdon: '',
                    status: '',
                    updatedon: '',
                    orderno: '',
                    dsordersid: '',
                    feedback: ''
                }
            ];
            dispatch({ type: STORE_NOTIFICATIONS, notifications } as AnyAction);
        }

    }).catch(function (error: AxiosResponse) {
        // ==> console.error(error);
        const notificationCount = 0;
        dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);
        notifications = [
            {
                rowno: '1',
                id: '',
                message: 'No notifications',
                createdon: '',
                status: '',
                updatedon: '',
                orderno: '',
                dsordersid: '',
                feedback: ''
            }
        ];
        dispatch({ type: STORE_NOTIFICATIONS, notifications } as AnyAction);
    });
    return true;
};

export const readNotifications = (notification: NotificationsType) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        if (notification.id) {
            const message = {
                messageid: notification.id
            };

            axios({
                method: 'POST',
                url: `${getState().environment.API_URL}updateNotification`,
                headers: {
                    sessionid: getState().user.userDetails.s || ''
                },
                data: message
            }).then(function (response: AxiosResponse) {
                getNotifications(dispatch, getState);

            }).catch(function (error: AxiosResponse) {
                // ==> console.error(error);
            });
        }

    };
};

export const readAllNotification = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

    axios({
        method: 'POST',
        url: `${getState().environment.API_URL}updateAllNotifications`,
        headers: {
            sessionid: getState().user.userDetails.s || ''
        },
        data: {
            user: getState().user.userDetails.userName
        }
    }).then(function (response: AxiosResponse) {
        getNotifications(dispatch, getState);

    }).catch(function (error: AxiosResponse) {
        // ==> console.error(error);
    });
};

export const openVideoPlayerURL = (videoFiles: GetFileData[]) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        let videoSignedUrl: string[] = [];

        for (const videoUrl of videoFiles) {

            const encodedFilepath = encodeURIComponent(videoUrl.filename);

            let downloadFrom = 'getDownloadUrl';

            if (videoUrl.oci_status && videoUrl.oci_status === '1') {
                downloadFrom = 'getODownloadUrl';
            }

            await axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
                method: 'GET',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    sessionid: getState().user.userDetails.s || ''
                }
            }).then(response => {
                videoSignedUrl.push(response.data.signedUrl);
            });

        }

        if (videoSignedUrl.length > 0) {
            const openVideoPlayer = true;
            dispatch({ type: STORE_OPEN_VIDEO_PLAYER, openVideoPlayer } as AnyAction);
            dispatch({ type: STORE_VIDEO_SIGNED_URL, videoSignedUrl } as AnyAction);
        } else {
            const openVideoPlayer = true;
            dispatch({ type: STORE_OPEN_VIDEO_PLAYER, openVideoPlayer } as AnyAction);
            videoSignedUrl = [];
            dispatch({ type: STORE_VIDEO_SIGNED_URL, videoSignedUrl } as AnyAction);

            const errorFileUploadedOpen = true;
            const errorfilemsg = 'Something went wrong! Can\'t play the video.';
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

    };
};
export const openVideoPlayerURLArray = (arrayUrl: string[], fpath: string) => {
    return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {

        let videoSignedUrl: string[] = [];

        let fullpath: string[] = [];

        if (fpath.indexOf('/Initial_Scan') !== -1) {
            fullpath = fpath.split('/Initial_Scan');
        } else if (fpath.indexOf('/Final_Scan') !== -1) {
            fullpath = fpath.split('/Final_Scan');
        } else {
            fullpath = [fpath];
        }

        if (arrayUrl.length > 0 && fullpath.length > 0) {

            for (const videoUrl of arrayUrl) {

                const encodedFilepath = encodeURIComponent(`${fullpath[0]}/Video/${videoUrl}`);

                let downloadFrom = 'getDownloadUrl';

                if (videoUrl === 'download from oracle') { // Temporarily
                    downloadFrom = 'getODownloadUrl';
                }

                await axios(`${getState().environment.API_URL}${downloadFrom}?fullPath=${encodedFilepath}`, {
                    method: 'GET',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        sessionid: getState().user.userDetails.s || ''
                    }
                }).then(response => {
                    videoSignedUrl.push(response.data.signedUrl);
                });

            }
        }

        if (videoSignedUrl.length > 0) {
            const openVideoPlayer = true;
            dispatch({ type: STORE_OPEN_VIDEO_PLAYER, openVideoPlayer } as AnyAction);
            dispatch({ type: STORE_VIDEO_SIGNED_URL, videoSignedUrl } as AnyAction);
        } else {
            const openVideoPlayer = true;
            dispatch({ type: STORE_OPEN_VIDEO_PLAYER, openVideoPlayer } as AnyAction);
            videoSignedUrl = [];
            dispatch({ type: STORE_VIDEO_SIGNED_URL, videoSignedUrl } as AnyAction);

            const errorFileUploadedOpen = true;
            const errorfilemsg = 'Something went wrong! Can\'t play the video.';
            dispatch({ type: STORE_ERROR_FILES_UPLOADED_MSG, errorfilemsg } as AnyAction);
            dispatch({ type: STORE_ERROR_FILES_UPLOADED, errorFileUploadedOpen } as AnyAction);
        }

    };
};
export const closeVideoPlayer = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const openVideoPlayer = false;
    dispatch({ type: STORE_OPEN_VIDEO_PLAYER, openVideoPlayer } as AnyAction);
    const videoSignedUrl = '';
    dispatch({ type: STORE_VIDEO_SIGNED_URL, videoSignedUrl } as AnyAction);
};

export const startTimerNoti = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (notiTimer) {
        clearInterval(notiTimer);
    }
    notiTimer = setInterval(() => { getRegularIntervalData(dispatch, getState); }, 600000);
};

export const stopTimerNoti = (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    if (notiTimer) {
        clearInterval(notiTimer);
    }
    const notificationCount = 0;
    dispatch({ type: STORE_NOTIFICATIONS_COUNT, notificationCount } as AnyAction);
    const notifications: NotificationsType[] = [];
    dispatch({ type: STORE_NOTIFICATIONS, notifications } as AnyAction);
};
// export const setNotifications = window.setInterval('getNotifications(dispatch, getState)', 10000);



// WEBPACK FOOTER //
// ./src/actions/landingPageAction.ts